import { ArrowDownIcon } from '../icons';
import styles from './interior.module.css';

interface JumpNavigationProps {
  id?: string;
  label: string;
  items: readonly { id: string; label: string }[];
}

export function JumpNavigation({ id, label, items }: JumpNavigationProps): React.ReactElement {
  return (
    <nav id={id} aria-label={label} className={styles.jumpNavigation}>
      <p>{label}</p>
      <ul>
        {items.map((item) => (
          <li key={item.id}>
            <a href={`#${item.id}`}>
              {item.label}
              <ArrowDownIcon className={styles.jumpArrow} />
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
